import Ajax from 'global/od/Ajax';
import addToCartPanelTypeData from 'global/addToCart/addToCartPanelTypeData';

export const addToCart = (data = {}) => {
	return Ajax({
		url: addToCartPanelTypeData(data?.panelType, 'url'),
		method: 'POST',
		dataType: 'html',
		data,
	});
};

export default addToCart;
